import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import { COMMUNITIES_COMMON } from '../../../../constants/strings';
import ClickableElement from '../../../ClickableElement';
import { COMMUNITIES_USER_ROLES } from '../../../../constants';
import { IDS } from '../../../../constants/ids';
import ListItem from '../ListItem';
import styles from '../index.styl';

const List = ({
  items,
  title,
  showMenu,
  intl: { formatMessage },
  limitList,
  onListItemMenuClick,
  onSeeAll,
  loggedUserId,
  type,
}) => {
  // show short or full list
  const currentList = limitList ? items.slice(0, limitList) : items;
  const isShowSeeAllBtn = limitList && limitList < items.length - 1;
  const seeAllID =
    type === COMMUNITIES_USER_ROLES.MODERATOR
      ? IDS.COMMUNITY.SEE_ALL_MODERATORS
      : IDS.COMMUNITY.SEE_ALL_MEMBERS;

  return (
    <div styleName="list">
      <div styleName="list__header">
        <p children={title} />
        <If condition={isShowSeeAllBtn}>
          <ClickableElement onClick={onSeeAll} id={seeAllID}>
            <span>{formatMessage(COMMUNITIES_COMMON.seeAll)}</span>
          </ClickableElement>
        </If>
      </div>
      <ul>
        {currentList.map(item => (
          <li key={item.id}>
            <ListItem
              item={item}
              avatarSize={24}
              isCanBlockUser
              onClick={onListItemMenuClick}
              loggedUserId={loggedUserId}
              type={type}
              showMenu={showMenu}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  showMenu: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  limitList: PropTypes.number,
  onSeeAll: PropTypes.func.isRequired,
  onListItemMenuClick: PropTypes.func.isRequired,
  loggedUserId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};

List.defaultProps = {
  title: '',
  limitList: 0,
};

export default compose(
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
)(List);



// WEBPACK FOOTER //
// ./src/components/Community/About/List/index.jsx